import React from 'react'
import { Box } from '@chakra-ui/react'
import { graphql, useStaticQuery } from 'gatsby'
import BackgroundImage from '../../components/BackgroundImage'
import CenterContainer from '../../components/CenterContainer'
// import xiahai from './xiahai.png'
// import jiangmei from './jiangmei.png'
import useGatsbyImage from '../../hooks/useGatsbyImage'


const Footer = ({ temple }) => {

  const data = useStaticQuery(graphql`
    query footerQuery {
      allFile(
        filter: { relativePath: { glob: "containers/Footer/*.@(png|jpg)" } }
      ) {
        nodes {
          ...backgroundImage
        }
      }
    }
  `)
  // console.log(temple)
  const image = useGatsbyImage(data.allFile, `${temple}.png`)
  if (!image) return null
  return (
    <Box as="footer" pos="absolute" bottom={0} left={0} right={0} bg={"custom.primaryBg"}>
      <CenterContainer bg={'custom.lightSkin'} py="0.125rem">
        <Box width="12.5em">
          <BackgroundImage image={image} ratio={357 / 45} />
        </Box>
      </CenterContainer>
    </Box>
  )
}

export default Footer
